import type { Key } from './de';

export const en: Record<Key, string> = {
  'app.name': 'Financial Tool',
  'app.area': 'Area',
  "mg.areaTarget": "Area target margin",
  "mg.col.target": "Target",
  "mg.targetOf": "Target margin {p}",
  "mg.targetInvalid": "Please enter 0 to 100.",
  "mg.targetArea": "(area)",
  "mg.targetDefault": "(default)",
  "mg.targetHint": "Change target margin; leave empty = area target or default",
  "mg.title": "Margin",
  "mg.lead": "Revenue, costs and margin per project from the Power BI export (Workday “Project Margin”). Only projects with revenue are shown; months without revenue count as open and are not included.",
  "mg.import": "Import export",
  "mg.year": "Year",
  "mg.target": "Target margin",
  "mg.last": "Last imported on {at} by {by} ({file}), export up to {m}",
  "mg.empty": "No margin data yet. Please import the Power BI export.",
  "mg.emptyYear": "There are no projects with revenue for {y}.",
  "mg.kpi.ns": "Revenue",
  "mg.kpi.nsSub": "Net sales, {n} projects",
  "mg.kpi.cost": "Project costs",
  "mg.kpi.costSub": "Staff and subcontracting",
  "mg.kpi.margin": "Project margin",
  "mg.kpi.marginSub": "Target margin {p}",
  "mg.kpi.hours": "Hours",
  "mg.kpi.hoursSub": "of which {n} free",
  "mg.kpi.perHour": "Per hour",
  "mg.kpi.perHourSub": "Revenue / costs per hour",
  "mg.months": "Margin per month",
  "mg.legendNs": "Revenue",
  "mg.legendCost": "Costs",
  "mg.monthOpen": "open",
  "mg.monthHint": "Percent = margin of the month",
  "mg.find": "Findings",
  "mg.find.none": "Nothing stands out.",
  "mg.lvl.urgent": "Urgent",
  "mg.lvl.check": "Check",
  "mg.find.negative": "{p}: negative margin in {m} ({v})",
  "mg.find.falling": "{p} is falling: {v} in {m}, average {avg}",
  "mg.find.below": "{p} is only at {v} for the year (target {g})",
  "mg.hidden": "{n} projects with costs or hours only are hidden.",
  "mg.projects": "Projects",
  "mg.count": "{n} of {all} · by revenue",
  "mg.f.all": "All",
  "mg.f.crit": "Critical",
  "mg.f.watch": "Watch",
  "mg.f.ok": "On target",
  "mg.state.crit": "critical",
  "mg.state.watch": "watch",
  "mg.state.ok": "on target",
  "mg.falling": "falling lately",
  "mg.noTool": "not in the tool",
  "mg.col.project": "Project",
  "mg.col.customer": "Customer",
  "mg.col.hours": "Hours",
  "mg.col.ns": "Revenue",
  "mg.col.cost": "Costs",
  "mg.col.margin": "Margin",
  "mg.col.pct": "Margin %",
  "mg.col.perHour": "€/h",
  "mg.col.trend": "Trend",
  "mg.sum": "Total",
  "mg.customers": "By customer",
  "mg.custLine": "{ns} revenue · {m} margin · {h} h",
  "mg.im.title": "Import Power BI export",
  "mg.im.lead": "In Power BI, export the “Project Margin” table (project, Calendar_Period, Commercial Hours, Net Sales, Project Costs …) to Excel and drop it here. New months are added, changed values are updated, months missing from the export stay as they are. You see all changes before applying.",
  "mg.im.drop": "Drag the Excel file here or click",
  "mg.im.checking": "Checking …",
  "mg.im.close": "Close",
  "mg.im.state.new": "new",
  "mg.im.state.changed": "changed",
  "mg.im.state.unchanged": "unchanged",
  "mg.im.newMonths": "New months: {m}",
  "mg.im.noNewMonths": "No new month",
  "mg.im.range": "Export: {from} to {to} · {n} rows",
  "mg.im.skipped": "{n} rows skipped",
  "mg.im.apply": "Apply ({n})",
  "mg.im.applying": "Applying …",
  "mg.im.nothing": "No changes – everything is already in the tool.",
  "mg.im.applied": "Applied: {new} new, {changed} updated",
  "mg.im.unmatched": "{n} Workday projects without a project in the tool (imported anyway): {list}",
  "mg.im.showUnchanged": "Show unchanged",
  "mg.im.col.month": "Month",
  'app.loading': 'Loading …',
  'app.toLogin': 'Redirecting to sign-in …',
  'app.noAccess.title': 'No access yet',
  'app.noAccess.text': 'Your account has not been activated for the Financial Tool yet. Please contact Matthias Brunner.',
  'app.signedInAs': 'Signed in as {email}',
  'app.logout': 'Sign out',
  'app.down.title': 'The tool is currently unavailable',
  'app.down.text': '{reason}. Please reload in a few minutes.',
  'app.reload': 'Reload',
  'app.serverStatus': 'Server responded with {status}',
  'app.serverDown': 'Server unreachable',
  'app.toLight': 'Switch to light',
  'app.toDark': 'Switch to dark',
  'app.theme': 'Light / dark',
  'app.lang': 'Language',
  'app.toStart': 'Go to start',
  'app.modules': 'Modules',
  'crumb.root': 'Financial Tool · {area}',
  'crumb.admin': 'Financial Tool · CBS · Administration',

  'nav.start': 'Start',
  'nav.orders': 'Orders',
  'nav.projects': 'Projects',
  'nav.invoicing': 'Invoicing',
  'nav.issues': 'Open items',
  'nav.forecast': 'Forecast',
  'nav.margin': 'Margin',
  'nav.soon': 'soon',
  'nav.admin': 'Admin',
  'nav.issuesBadge': '{n} to check',

  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.saving': 'Saving …',
  'common.close': 'Close',
  'common.all': 'All',
  'common.search': 'Search',
  'common.reset': 'Reset',
  'common.customer': 'Customer',
  'common.project': 'Project',
  'common.pm': 'PM',
  'common.status': 'Status',
  'common.choose': 'Please choose',
  'common.chooseCustomerFirst': 'Choose customer first',
  'common.archive': 'Delete',
  'common.archiveConfirm': 'Really delete?',
  'common.archiving': 'Deleting …',
  'common.edit': 'Edit',
  'common.open': 'Open',
  'common.sum': 'Total',
  'common.noNumber': 'no number',
  'common.myProjects': 'My projects',
  'common.withoutPm': 'Without PM',
  'common.filter': 'Filter',
  'common.none': 'None.',
  'common.amount': 'Amount',
  'common.date': 'Date',
  'common.quarter': 'Quarter',
  'common.order': 'Order',
  'common.warranty': 'Warranty',
  'common.export': 'Excel export',
  'common.exporting': 'Creating Excel …',
  'common.notFound.title': 'Page not found',

  'status.warranty': 'Warranty',
  'status.overdrawn': 'Overdrawn',
  'status.settled': 'Fully billed',
  'status.nearlyUsed': 'Nearly used',
  'status.unbilled': 'Not billed',
  'status.active': 'Active',
  'status.open': 'Open volume',

  'cp.collapse': 'Collapse',
  'cp.expand': 'Expand',
  'cp.collapseAll': 'Collapse all',
  'cp.expandAll': 'Expand all',
  'fc.kpisTitle': 'Key figures {y}',
  'fc.sum.avg': 'Avg. per month',
  'fc.cols': 'Columns',
  'fc.cols.m': 'Months',
  'fc.cols.q': 'Quarters',
  'fc.cols.s': 'Totals only',
  'dh.tableTitle': 'Areas ({n})',
  'inbox.toReview': 'to review',
  'order.projectsN': '{n} projects',
  'order.usedPct': '{p} % used',
  'order.historyN': '{n} entries',
  'mg.kpisTitle': 'Key figures {y}',
  'mg.custN': '{n} customers',
  'pa.groupsN': '{n} cost groups',
  'issue.contractTypeMissing.t': 'Contract {contract}: contract type missing',
  'issue.contractTypeMissing.d': 'Please choose the type on the contract (frame, T&M, fixed price, flat fee).',
  'issue.invoiceMissing.t': 'Contract {contract}: invoice for {period} missing',
  'issue.invoiceMissing.d': 'Due on the last working day ({date}). Please record at least a draft invoice in the tool.',
  'issue.undistributed.t': 'Order {order}: {amount} released but not allocated',
  'issue.undistributed.d': '{released} is released. Please allocate the rest to projects or mark it as not released.',
  'cf.type': 'Contract type',
  'cf.err.type': 'Please choose the contract type.',
  'cf.cycle': 'Invoice planned',
  'cf.cycle.month': 'monthly',
  'cf.cycle.quarter': 'quarterly',
  'cf.cycleHelp': 'By the last working day of the month or quarter at least one (draft) invoice must be in the tool, otherwise an open item appears.',
  'ctype.frame': 'Frame contract',
  'ctype.frame.d': 'budget over years, called off via individual orders',
  'ctype.tm': 'Service contract (T&M)',
  'ctype.tm.d': 'by effort, with proof of performance',
  'ctype.fixed': 'Work contract (fixed price)',
  'ctype.fixed.d': 'fixed price, invoiced per milestone/acceptance',
  'ctype.flat': 'Flat fee / maintenance',
  'ctype.flat.d': 'fixed amount per month or quarter',
  'ctype.short.frame': 'Frame',
  'ctype.short.tm': 'T&M',
  'ctype.short.fixed': 'Fixed price',
  'ctype.short.flat': 'Flat fee',
  'ctype.none': 'Type missing',
  'of.total': 'Order value per order',
  'of.totalPh': 'empty = sum of allocation',
  'of.totalHelp': 'Total amount of the order. Leave empty if everything is allocated.',
  'of.totalPdf': 'from the PDF: {v}',
  'of.held': 'of which not released',
  'of.heldHelp': 'Part the customer does not release (yet). Does not count as ordered nor against the contract.',
  'of.heldReason': 'Reason',
  'of.held.r1': 'Customer releases only after acceptance',
  'of.held.r2': 'Option – only when called off',
  'of.held.r3': 'Travel / licences (not for projects)',
  'of.held.own': 'Own reason …',
  'of.held.ownPh': 'Reason in your own words',
  'of.heldUntil': 'Release expected',
  'of.heldUntilHelp': 'Optional – may stay empty.',
  'of.minusHeld': '− not released',
  'of.released': '= released (allocatable)',
  'of.distributed': 'allocated',
  'of.restRel': 'Released, not allocated',
  'of.overRel': 'over-allocated',
  'of.restRelMsg': '{rest} released but not assigned to a project. You can save – it shows up as an open item.',
  'of.relOk': 'All good: the released amount is fully allocated.',
  'of.err.heldNoTotal': 'Please enter the order value to hold back a part.',
  'of.err.heldOver': 'The part not released is larger than the order value.',
  'of.err.overRelease': '{over} more is allocated than released ({rel}). Lower the amounts or increase the release.',
  'of.err.heldReason': 'Please give a reason for the part not released.',
  'of.err.shareOver': '{project}: {over} more than its share in the contract. Please adjust or raise the share in the contract.',
  'of.shareRestLine': 'Share in contract: {rest} left afterwards',
  'of.shareOverLine': 'exceeds the share in the contract by {over}',
  'od.release': 'Order value and release',
  'od.releasedShort': 'Released',
  'od.heldShort': 'Not released',
  'od.distributedShort': 'Allocated',
  'od.releasedOpen': 'released, open',
  'od.releaseBtn': 'Record release',
  'od.heldWhy': 'Reason: {reason}',
  'od.heldUntil': 'release expected {d}',
  'od.heldNoDate': 'no release date',
  'od.overReleased': '{over} more has been billed than released. Please check the invoice or clarify the release.',
  'od.released': 'Release recorded',
  'od.releaseAmount': 'Amount now released',
  'od.releaseHelp': 'At most {max}. Afterwards you can allocate it to projects.',
  'od.releaseNote': 'Note (optional)',
  'od.releaseNotePh': 'e.g. customer email of 12 March',
  'od.releaseErr': 'Please enter an amount between €0.01 and {max}.',
  'ct.view': 'View',
  'ct.view.cards': 'Cards',
  'ct.view.table': 'Table',
  'ct.card.use': 'ordered {o} of budget · billed {b}',
  'ct.card.noBudget': 'no budget set – only orders counted',
  'ct.card.term': '{p} of the term',
  'ct.kpi.cust': '{c} customers · {p} projects',
  'ct.kpi.budget': 'Total budget',
  'ct.kpi.withBudget': '{n} of {all} with budget',
  'ct.kpi.allContracts': 'across all contracts',
  'ct.kpi.inBudget': 'in contracts with budget',
  'ct.kpi.attention': 'Attention',
  'ct.kpi.ending': '{n} ending soon',
  'ct.kpi.tight': '{n} nearly used',
  'ct.kpi.noBudget': '{n} without budget',
  'ct.kpi.noType': '{n} without type',
  'ct.filterNoType': 'Without contract type',
  'me.menu': 'My profile',
  'photo.menu': 'Change profile photo',
  'photo.title': 'Profile photo',
  'photo.lead': 'Your photo appears next to your name throughout the tool – in history, responsibilities and lists. Optional: without a photo your initials stay.',
  'photo.drop': 'Drop an image here or',
  'photo.choose': 'choose one',
  'photo.formats': 'JPG, PNG or WebP · cropped round and scaled to 256 px',
  'photo.zoom': 'Zoom',
  'photo.dragHint': 'Drag the image to move it',
  'photo.preview': 'Profile photo preview',
  'photo.remove': 'Remove photo',
  'photo.saved': 'Profile photo saved',
  'photo.removed': 'Profile photo removed',
  'photo.err.type': 'Please choose a JPG, PNG or WebP image.',
  'photo.err.size': 'The image is too large (max. 15 MB).',
  'photo.size.list': 'Lists',
  'photo.size.history': 'History',
  'photo.size.head': 'Header',
  'photo.size.start': 'Start page',
  'photo.privacy': 'Only you can change your photo. Admins can remove an inappropriate one.',
  'photo.adminRemove': 'Remove profile photo',
  'photo.adminRemoved': 'Removed profile photo of {name}',
  'photo.has': 'with photo',
  'start.team': 'Team in this area',
  'start.teamProjects': '{n} projects',
  'start.teamOpen': '{n} open',
  'role.admin': 'Admin',
  'role.pm': 'Project manager',
  'role.reader': 'Read-only',
  'role.finance': 'Finance',
  'uf.financeHelp': 'Finance sees everything in the selected areas – including margin, monthly snapshots and the financial report – and only changes invoices: payment status, paid date, warranty and Workday sync. Orders, contracts and projects are view-only.',
  'shell.finance': 'Finance · edit invoices, otherwise view only',
  'if.financeOnly': 'As finance you can change payment status, due date, paid date and warranty here.',

  'start.hello': 'Hello, {name}',
  'start.sub': 'Area {area} · signed in as {role}',
  'start.statusTitle': 'Build status',
  'start.statusText': 'From now on the tool is the basis for orders and invoices. The Excel file is no longer maintained.',
  'start.done': 'Done',
  'start.open': 'Open',
  'start.check': 'Checking …',
  'start.error': 'Error',
  'start.login': 'Sign-in with {email}',
  'start.db': 'Database connection',
  'start.version': 'version {v}',
  'start.import': 'Data import 2026 from Excel',
  'start.edit': 'Create and edit orders and invoices, with history',
  'start.admin': 'Admin: grant access, assign PMs and targets',
  'start.lang': 'German and English',
  'start.projects': 'Projects & targets (overview with progress)',
  'start.pdf': 'Read orders from PDF',
  'placeholder.text': 'This view is coming in {step}. The design follows draft v4.',
  'placeholder.next': 'one of the next steps',

  'orders.title': 'Orders',
  'orders.new': 'New order',
  'orders.searchPh': 'Order no., project …',
  'orders.empty': 'No order matches these filters.',
  'orders.col.number': 'Order no.',
  'orders.col.orderedOn': 'Ordered on',
  'orders.col.lastInvoice': 'Last invoice',
  'orders.col.volume': 'Volume',
  'orders.col.billed': 'Billed',
  'orders.col.rest': 'Remaining',
  'orders.col.usage': 'Usage',
  'orders.count': '{n} orders',

  'order.kind.order': 'Customer order',
  'order.kind.warranty': 'Warranty',
  'order.customer': 'Customer',
  'order.orderedOn': 'Ordered on',
  'order.service': 'Service',
  'order.invoices': 'Invoices',
  'order.used': '{p} used',
  'order.note': 'Note',
  'order.alloc': 'Allocation to projects',
  'order.allocHint': 'Total = order volume',
  'order.col.share': 'Share',
  'order.unallocated': 'No share',
  'order.setShare': 'Set share',
  'order.noLines': 'No lines yet. Use “Edit” to add projects and amounts.',
  'order.invoicesTitle': 'Invoices ({n})',
  'order.addInvoice': 'Add invoice',
  'order.noInvoices': 'No invoice on this order yet.',
  'order.history': 'Change history',
  'order.historyHint': 'Who changed what and when',
  'order.fromImport': 'from Excel import',
  'order.fromWorkday': 'from Workday import',
  'order.saved': 'Order saved',
  'invoice.saved': 'Invoice saved',

  'hist.order': 'Order',
  'hist.line': 'Line {ref}',
  'hist.invoice': 'Invoice {ref}',
  'hist.create': '{what} created',
  'hist.update': '{what} changed',
  'hist.delete': '{what} removed',
  'hist.restore': '{what} restored',
  'hist.otherOrder': 'other order',
  'field.order_number': 'Order number',
  'field.kind': 'Type',
  'field.customer_id': 'Customer',
  'field.order_date': 'Ordered on',
  'field.service_from': 'Service from',
  'field.service_to': 'Service to',
  'field.note': 'Note',
  'field.amount_cents': 'Amount',
  'field.project_id': 'Project',
  'field.order_id': 'Order',
  'field.invoice_number': 'Workday no.',
  'field.invoice_date': 'Date',

  'of.new': 'New order',
  'of.edit': 'Edit order {n}',
  'of.kind': 'Type',
  'of.number': 'Order number (PO)',
  'of.numberPh': 'e.g. F46XW9J',
  'of.orderedOn': 'Ordered on',
  'of.from': 'Service from',
  'of.to': 'Service to',
  'of.alloc': 'Allocation to projects',
  'of.chooseProject': 'Choose project',
  'of.lineProject': 'Project line {n}',
  'of.lineAmount': 'Amount line {n} in euros',
  'of.lineRemove': 'Remove line {n}',
  'of.addProject': '+ Add project',
  'of.volume': 'Volume',
  'of.note': 'Note',
  'of.notePh': 'e.g. follow-up order to F46XW9J, contact person …',
  'of.err.customer': 'Please choose a customer.',
  'of.err.number': 'Please enter the order number (PO).',
  'of.err.project': 'Choose a project for every line.',
  'of.err.amount': 'Enter a valid amount for every line, e.g. 120,000.00.',
  'of.err.lines': 'Enter at least one line with project and amount.',

  'inv.title': 'Invoicing',
  'inv.add': 'Add invoice',
  'inv.searchPh': 'Workday no., order no. …',
  'inv.period': 'Period',
  'inv.order': 'Order',
  'inv.withoutOrder': 'Without order',
  'inv.noOrder': 'No order',
  'inv.empty': 'No invoices for this selection.',
  'inv.col.number': 'Workday no.',
  'inv.count': '{n} invoices',
  'if.title': 'Invoice {n}',
  'if.number': 'Workday no.',
  'if.numberPh': 'e.g. 002CINV2026100101',
  'if.date': 'Invoice date',
  'if.amount': 'Net amount (€)',
  'if.err.number': 'Please enter the Workday invoice number.',
  'if.err.project': 'Please choose a project.',
  'if.err.amount': 'Please enter a valid amount, e.g. 12,500.00.',

  'issues.title': 'Open items',
  'issues.lead': 'The tool checks the data continuously. An item disappears by itself once it is resolved, e.g. when a follow-up order is recorded or an invoice is assigned correctly.',
  'issues.empty': 'Nothing open.',
  'issues.level.neg': 'Urgent',
  'issues.level.crit': 'Check',
  'issues.level.info': 'Note',
  'issues.warrantySuffix': ' (warranty)',
  'issue.overdrawn.t': 'Order {order} is {pct} billed',
  'issue.overdrawn.d': 'Billed {billed}, released {volume}. Invoices must not exceed the released amount – please check the invoice or clarify release/follow-up order.',
  'issue.nearlyUsed.t': 'Order {order} is nearly used up ({pct})',
  'issue.nearlyUsed.d': '{rest} remaining. Ask the customer for a follow-up order?',
  'issue.lineOverdrawn.t': '{project}: share of {order} overdrawn ({pct})',
  'issue.lineOverdrawn.d': '{billed} billed against a share of {volume}. Adjust the allocation?',
  'issue.noLines.t': 'Order {order} has no lines',
  'issue.noLines.d': 'Volume and project are missing. Please enter the allocation to projects.',
  'issue.notAllocated.t': '{project}: invoices on {order} without a share',
  'issue.notAllocated.d': '{billed} billed, but the order has no line for this project. Set a share or move the invoice.',
  'issue.withoutOrder.t': '{project}: {count} invoice(s) without an order',
  'issue.withoutOrder.d': '{billed}. Normal for customers without POs, otherwise assign an order.',
  'issue.noPm.t': '{count} project(s) without a PM',
  'issue.noPm.d': '{projects}. Without a PM a project does not appear under anyone’s “My projects”.',
  'issue.endingSoon.t': "Service period of {order} ends in {days} days",
  'issue.endingSoon.d': "Service period until {date}, no follow-up order for {projects}. Ask the customer for a follow-up order now.",

  'admin.title': 'Administration',
  'admin.tab.users': 'People',
  'admin.tab.projects': 'Projects & responsibilities',
  'admin.tab.import': 'Excel import',
  'users.lead': 'People listed here can sign in with their intive account. The email address must match the Microsoft sign-in exactly.',
  'users.add': 'Add person',
  'users.col.name': 'Name',
  'users.col.email': 'Email',
  'users.col.role': 'Role',
  'users.col.projects': 'Projects',
  'users.col.state': 'Status',
  'users.active': 'Active',
  'users.inactive': 'Deactivated',
  'users.pmOf': '{n} as PM',
  'users.deputyOf': '{n} as deputy',
  'users.deactivate': 'Deactivate',
  'users.deactivateConfirm': 'Really deactivate?',
  'users.restore': 'Reactivate',
  'users.you': '(you)',
  'users.roleHelp': 'Admin: everything incl. administration · Project manager: edit orders and invoices · Finance: view everything (incl. margin, report), maintain payments and warranty · Read-only: view only · Delivery Head: view all areas, with overview',
  'uf.new': 'Add person',
  'uf.edit': 'Edit {n}',
  'uf.name': 'Name',
  'uf.namePh': 'First name Last name',
  'uf.email': 'Email (intive account)',
  'uf.emailPh': 'firstname.lastname@intive.com',
  'uf.role': 'Role',
  'uf.err.name': 'Please enter the name.',
  'uf.err.email': 'Please enter a valid email address.',
  'uf.saved': 'Person saved',
  'uf.deactivated': 'Person deactivated',
  'uf.restored': 'Person active again',

  'projects.lead': 'Projects in area {area}. The PM belongs to the project. Orders and invoices inherit it automatically. The deputy also sees the project under “My projects”.',
  'projects.add': 'New project',
  'projects.year': 'Year',
  'projects.col.domain': 'Domain',
  'projects.col.deputy': 'Deputy',
  'projects.col.since': 'PM since',
  'projects.col.target': 'Target {y}',
  'projects.none': 'No projects.',
  'pf.new': 'Create new project',
  'pf.edit': 'Edit project {n}',
  'pf.customer': 'Customer',
  'pf.newCustomer': '+ New customer …',
  'pf.newCustomerName': 'Name of the new customer',
  'pf.name': 'Project name',
  'pf.domain': 'Domain',
  'pf.domainPh': 'e.g. Data & Analytics',
  'pf.pm': 'PM',
  'pf.deputy': 'Deputy',
  'pf.noPm': '– No PM –',
  'pf.noDeputy': '– None –',
  'pf.target': 'Target {y} (€)',
  'pf.targetPh': 'empty = no target',
  'pf.err.customer': 'Please choose or create a customer.',
  'pf.err.name': 'Please enter the project name.',
  'pf.err.pm': 'A new project needs a PM.',
  'pf.err.target': 'Please enter a valid target, e.g. 250,000.00, or leave it empty.',
  'pf.saved': 'Project saved',

  'app.noArea.title': 'Not assigned to an area yet',
  'app.noArea.text': 'You are signed in but not yet assigned to an area, so you cannot see any orders, projects or invoices. Please contact Matthias Brunner.',
  'app.noArea.admin': 'You are not assigned to any area and therefore see no data. Assign yourself to an area under Admin → People.',
  'app.areaSwitch': 'Switch area',
  'users.col.areas': 'Areas',
  'users.noArea': 'no area',
  'uf.areas': 'Areas',
  'uf.areasHelp': 'The person only sees orders, projects and invoices of these areas. Without an area they see nothing.',
  'admin.tab.areas': 'Areas',
  'areas.lead': 'Each area has its own customers, projects, orders and invoices. Anyone assigned to an area sees everything in it, and nothing else.',
  'areas.add': 'New area',
  'areas.col.name': 'Name',
  'areas.col.members': 'People',
  'areas.col.projects': 'Projects',
  'af.new': 'New area',
  'af.edit': 'Rename area {n}',
  'af.name': 'Name',
  'af.namePh': 'e.g. CBS',
  'af.hint': 'You are assigned to the new area automatically. Assign other people under “People”.',
  'af.err.name': 'Please enter a name.',
  'af.saved': 'Area saved',
  'pf.pmHelp': 'You can choose people assigned to area {area}.',

  'pz.title': 'Projects & targets',
  'pz.year': 'Year',
  'pz.allPms': 'All PMs',
  'pz.me': '(me)',
  'pz.legend.billed': 'billed',
  'pz.legend.ordered': 'ordered',
  'pz.legend.pace': 'expected today ({p})',
  'pz.count': '{n} projects',
  'pz.col.target': 'Target',
  'pz.col.ordered': 'Ordered',
  'pz.col.billed': 'Billed',
  'pz.col.open': 'Open ordered',
  'pz.col.progress': 'Progress',
  'pz.col.reach': 'Target reached',
  'pz.health.noTarget': 'No target',
  'pz.health.uncovered': 'Target not covered',
  'pz.health.behind': 'Behind plan',
  'pz.health.onTrack': 'On track',
  'pz.custOf': '{billed} of {target} · {p}',
  'pz.empty': 'No projects for this selection.',
  'pz.removeFilter': 'Remove filter',
  'pz.healthHelp': 'Target not covered: less than 50% of the target ordered. Behind plan: less than 80% of today’s expected amount billed.',
  'pz.trackLabel': '{project}: {billed} billed, {ordered} ordered, target {target}',
  'ck.kpis': 'Key figures {y}',
  'ck.target': 'Target {y}',
  'ck.targetSub': '{n} projects with a target',
  'ck.ordered': 'Order volume',
  'ck.orderedSub': '{p} of target ordered',
  'ck.billed': 'Billed',
  'ck.billedSub': '{p} of target · expected today {pace}',
  'ck.open': 'Open order volume',
  'ck.openSub': 'still to be billed',
  'ck.scopeAll': 'All',
  'ck.scopeMine': 'My projects',
  'ck.myIssues': 'Open items',
  'ck.allIssues': 'Show all →',
  'ck.noIssues': 'Nothing open.',
  'ck.quarters': 'Billed per quarter {y}',
  'ck.quarterHint': 'Click opens the invoices',
  'ck.recent': 'Latest invoices',
  'ck.allInvoices': 'Open invoicing →',
  'ck.projectsAtRisk': 'Projects behind plan or not covered',
  'ck.allProjects': 'Projects & targets →',
  'ck.noRisk': 'All projects on track.',

  'pdf.fromPdf': 'Read from PDF',
  'pdf.reading': 'Reading PDF …',
  'pdf.title': 'Order from PDF',
  'pdf.check': 'Suggestion from “{file}”. Please check all values before saving. The PDF is stored with the order.',
  'pdf.warn.orderNumber': 'Order number not recognised',
  'pdf.warn.orderDate': 'Order date not recognised',
  'pdf.warn.customer': 'Customer not recognised',
  'pdf.warn.positions': 'No lines with an amount recognised',
  'pdf.warn.totalMismatch': 'Sum of lines differs from the PDF total ({total})',
  'pdf.warn.project': 'Not every line could be matched to a project',
  'pdf.exists': 'This order number already exists in this area.',
  'pdf.openExisting': 'Open existing order',
  'pdf.lineFrom': 'from PDF: {text}',
  'pdf.drop': 'Drop the order PDF from your computer here or choose it – the fields are filled in automatically',
  'pdf.dropAgain': '“{file}” read · choose another PDF',
  'pdf.docs': 'Documents',
  'pdf.open': 'Open PDF',
  'pdf.replace': 'Replace PDF',
  'pdf.upload': 'Attach PDF',
  'pdf.none': 'No order PDF attached yet.',
  'pdf.saved': 'PDF attached',
  'field.pdf_name': 'PDF',

  'wd.button': 'Workday import',
  'wd.title': 'Import invoices from Workday',
  'wd.lead': 'In Workday, export the invoice report (e.g. “Find Customer Invoices”) with invoice number, date, project, customer PO and net amount as Excel or CSV and upload it here. A dry run comes first. Only new invoices are created; anything already in the tool (from Excel, entered manually or imported before) is never overwritten. Orders are matched by PO number.',
  'wd.drop': 'Drop the Workday export (.xlsx or .csv) here or choose it',
  'wd.check': 'Dry run',
  'wd.checking': 'Checking …',
  'wd.apply': 'Import {n} invoices',
  'wd.applying': 'Importing …',
  'wd.applied': 'Imported: {new} new invoices.',
  'wd.columns': 'Detected columns',
  'wd.col.number': 'Invoice no.', 'wd.col.date': 'Date', 'wd.col.project': 'Project', 'wd.col.customer': 'Customer', 'wd.col.po': 'PO', 'wd.col.amount': 'Amount', 'wd.col.status': 'Status',
  'wd.state.new': 'New', 'wd.state.differs': 'Differs (kept)', 'wd.state.unchanged': 'Unchanged', 'wd.state.unmatched': 'Project missing',
  'wd.mapTitle': 'Assign projects',
  'wd.mapLead': 'The tool does not know these Workday projects yet. Choose the matching project; the assignment is remembered for future imports.',
  'wd.mapSkip': '– do not import –',
  'wd.recheck': 'Check again with assignment',
  'wd.rows': 'Invoices',
  'wd.wdProject': 'Workday project',
  'wd.note.po_unknown': 'PO {po} does not exist in the tool',
  'wd.note.no_date': 'no date',
  'wd.skipped': '{n} rows skipped (cancelled, draft or no amount)',
  'wd.showUnchanged': 'Show unchanged',
  'wd.nothing': 'Nothing to import – everything is already in the tool.',

  'imp.title': 'Import data from Excel',
  'imp.lead': 'Select the orders & invoices files for the years. First comes a dry run that saves nothing. Then you can apply. Re-importing only changes what changed in Excel; nothing is deleted.',
  'imp.drop': 'Drop Excel files here or <u>choose</u>',
  'imp.dry': 'Dry run',
  'imp.checking': 'Checking …',
  'imp.apply': 'Apply',
  'imp.applying': 'Applying …',
  'imp.applied': 'Applied',
  'imp.fixFirst': 'Fix the errors in Excel first.',
  'imp.dryTitle': 'Dry run: this would happen',
  'imp.result': 'Result',
  'imp.rows': '{y}: {n} rows',
  'imp.col.area': 'Area',
  'imp.col.new': 'New',
  'imp.col.changed': 'Changed',
  'imp.col.unchanged': 'Unchanged',
  'imp.findings': 'Findings ({n})',
  'imp.row': '{y} · row {n}',
  'imp.more': ' and {n} more',
  'imp.level.error': 'Error',
  'imp.level.warn': 'Check',
  'imp.level.info': 'Note',
  'imp.c.customers': 'Customers',
  'imp.c.projects': 'Projects',
  'imp.c.targets': 'Annual targets',
  'imp.c.orders': 'Orders',
  'imp.c.orderLines': 'Order lines',
  'imp.c.invoices': 'Invoices',
  'nav.help': 'Help',
  'help.title': 'Handbook',
  'help.toc': 'Contents',
  'env.test': 'TEST ENVIRONMENT – changes here do not affect the real data.',
  'env.dev': 'LOCAL DEVELOPMENT',
  'sync.title': 'Workday sync',
  'sync.never': 'No sync with Workday yet.',
  'sync.kind.auto': 'automatic via {by}',
  'sync.kind.manual': 'upload by {by}',
  'sync.new': '{n} new invoice(s)',
  'sync.nothingNew': 'nothing new',
  'sync.unmatched': '{n} without project mapping',
  'sync.differs': '{n} differ (unchanged)',
  'sync.failed': 'aborted',
  'sync.lastSuccess': 'Last successful sync: {at}',
  'sync.pending': 'Requested by {by} on {at}. Will be done with the next run (hourly, Mon–Fri 8am–7pm).',
  'sync.now': 'Sync now',
  'sync.requesting': 'Requesting …',
  'sync.requested': 'Requested',
  'sync.details': 'Details',
  'sync.hide': 'Less',
  'sync.newList': 'Newly added ({n})',
  'sync.unmatchedList': 'Not imported, project unknown ({n})',
  'sync.unmatchedHint': 'Map the project once and the next run imports them:',
  'sync.history': 'Recent syncs',
  'role.deliveryHead': 'Delivery Head',
  'area.viewOnly': 'view only',
  'area.viewOnlyOpt': '{name} (view only)',
  'area.viewOnlyHelp': 'You see this area as Delivery Head. Only people assigned to the area can make changes.',
  'users.allAreas': 'all areas',
  'uf.dhAddon': 'Additionally Delivery Head (view all areas)',
  'uf.dhHelp': 'Delivery Head sees all areas and the overview. In areas the person is not assigned to, they can only view.',
  'dh.title': 'All areas {y}',
  'dh.hint': 'Click an area to show its cockpit',
  'dh.areas': '{n} areas',
  'dh.issues': '{u} urgent · {c} to check',
  'dh.col.risk': 'Projects at risk',
  'dh.urgent': '{n} urgent',
  'dh.check': '{n} check',
  'dh.open': 'Open →',
  'dh.current': 'selected',
  'dh.reachLabel': '{p} billed, target to date {pace}',
  'scan.title': 'Order folders',
  'scan.noFolders': 'No project has an order folder yet. Add the folder under Administration → Projects & responsibilities.',
  'scan.never': '{n} folders set, not scanned yet.',
  'scan.pending': 'Requested by {by} on {at}. Will be done with the next run (hourly, Mon–Fri 8am–7pm).',
  'scan.now': 'Scan now',
  'scan.folders': '{n} folders',
  'scan.scanned': '{n} PDFs checked',
  'scan.new': '{n} new order(s)',
  'scan.dup': '{n} already exist',
  'scan.err': '{n} unreadable',
  'inbox.title': 'Orders found ({n})',
  'inbox.hint': 'From the order folders. Review and create, or dismiss.',
  'inbox.col.file': 'File',
  'inbox.col.found': 'Recognised',
  'inbox.unreadable': 'unreadable',
  'inbox.exists': 'exists already:',
  'inbox.check': 'please check',
  'inbox.ready': 'fully recognised',
  'inbox.manual': 'Create manually',
  'inbox.review': 'Review & create',
  'inbox.attach': 'Attach PDF',
  'inbox.attached': 'PDF attached to the order',
  'inbox.dismiss': 'Dismiss',
  'inbox.dismissed': 'Item dismissed',
  'inbox.reanalyze': 'Recognise again',
  'inbox.reanalyzed': 'Items recognised again',
  'pf.folder': 'Order folder',
  'pf.folderPh': 'https://smtsoftwareservices.sharepoint.com/…/02 - Purchase Orders',
  'pf.folderHelp': 'SharePoint link to the folder with the order PDFs (in SharePoint: open the folder → "Copy link" or the browser address) or a local OneDrive path. Subfolders per year/quarter are included; PDFs from 1 January of the current year are considered (in Q1 also the previous year).',
  'pf.folderTag': 'order folder',
  'pf.workday': 'Workday project ID',
  'pf.workdayHelp': 'e.g. PROJECT-13113. Links Workday invoices and the forecast file (iFC) to the project.',
  'pf.err.workday': 'Please enter the Workday project ID as PROJECT-12345.',
  'tokens.title': 'API keys',
  'tokens.lead': 'For scripts that access the tool on your behalf, e.g. the order folder scan on your computer. The key is shown only once.',
  'tokens.add': 'New key',
  'tokens.name': 'Label',
  'tokens.namePh': 'e.g. order folder scan laptop',
  'tokens.created': 'Created',
  'tokens.used': 'Last used',
  'tokens.never': 'never',
  'tokens.revoke': 'Revoke',
  'tokens.copy': 'Copy this key now and store it safely. It will not be shown again:',
  'auto.title': 'Browser automation',
  'auto.lead': 'For the scheduled runs in Chrome (order folder scan, forecast sync). The key lives only in your Chrome on the SharePoint page and can only start syncs – nothing else. Valid for 180 days; a new key replaces the old one.',
  'auto.none': 'Not set up yet.',
  'auto.active': 'Set up',
  'auto.expires': 'valid until',
  'auto.create': 'Set up',
  'auto.renew': 'Set up again',
  'auto.revoke': 'Revoke',
  'auto.steps': 'How to store the key (once, in the Chrome that runs the automation):',
  'auto.step1': 'Open SharePoint (link below) and wait until the page has loaded.',
  'auto.step2': 'Press F12 → "Console" tab. If Chrome asks for "allow pasting", type it once and press Enter.',
  'auto.step3': 'Copy the line below, paste it into the console, press Enter. Then close F12.',
  'auto.copyLine': 'Copy line',
  'auto.copied': 'Copied',
  'auto.openSp': 'Open SharePoint',
  'auto.once': 'The line contains the key and is shown only now.',
  'admin.tab.tokens': 'API keys',
  'fc.title': "Forecast",
  'search.title': "Search",
  'search.button': "Search",
  'search.placeholder': "Order number, invoice, project, customer or page …",
  'search.hint': "Type at least 2 characters – or pick a page / view.",
  'search.none': "Nothing found.",
  'search.type.contract': "Contracts",
  'search.type.order': "Orders",
  'search.type.invoice': "Invoices",
  'search.type.project': "Projects",
  'search.type.customer': "Customers",
  'search.views': "Saved views",
  'search.pages': "Pages",
  'search.move': "select",
  'search.open': "open",
  'keys.title': "Keyboard shortcuts",
  'keys.ctrl': "Ctrl",
  'keys.search': "Open search",
  'keys.new': "Create new (orders, contracts, invoicing)",
  'keys.goStart': "Go to start",
  'keys.goOrders': "Go to orders",
  'keys.goProjects': "Go to projects",
  'keys.goInvoicing': "Go to invoicing",
  'keys.goForecast': "Go to forecast",
  'keys.goIssues': "Go to open items",
  'keys.help': "This overview",
  'keys.thenHint': "Press “G”, then the letter.",
  'views.button': "Views",
  'views.saveCurrent': "Save current filters as",
  'views.namePh': "e.g. My BMW orders",
  'views.empty': "No saved views yet.",
  'views.delete': "Delete view {n}",
  'views.page.bestellungen': "Orders",
  'views.page.invoicing': "Invoicing",
  'views.page.projekte': "Projects",
  'views.page.forecast': "Forecast",
  'views.page.offene-punkte': "Open items",
  'tour.label': "Introduction",
  'tour.skip': "Skip",
  'tour.back': "Back",
  'tour.next': "Next",
  'tour.finish': "Let’s go",
  'tour.restart': "Start introduction",
  'tour.1.t': "Welcome to the Financial Tool",
  'tour.1.d': "Orders, invoices, targets and forecast of your area come together here. The start page shows the key figures and what needs doing – switchable between “All” and “My projects”.",
  'tour.2.t': "Orders",
  'tour.2.d': "Create new orders manually or from the PDF. At the top you see “Orders found” from the projects’ SharePoint folders – review, create, done.",
  'tour.3.t': "Invoicing",
  'tour.3.d': "Invoices come automatically from Workday. “Sync now” fetches the latest state; invoices without an order show up under Open items.",
  'tour.4.t': "Forecast",
  'tour.4.d': "The forecast comes from the company forecast files. You see forecast and actuals per account and month – and what has not been ordered yet.",
  'tour.5.t': "Get there faster",
  'tour.5.d': "Ctrl+K (Mac: ⌘K) or “/” finds any order, invoice or project. “?” shows all shortcuts. Save favourite filters via “Views”. Help and the handbook are at the bottom left.",
  'fc.kpi.uncovered': "Not yet ordered",
  'fc.kpi.uncoveredSub': "Forecast to year end {rest}, open order volume {open}",
  'fc.col.uncovered': "Not ordered",
  'fc.col.uncoveredHelp': "Forecast from the current month on that is not covered by open order volume",
  'fc.chartView': "Chart view",
  'fc.keyForecast': "Forecast (Excel)",
  'fc.keyActual': "Actual (invoices)",
  'fc.keyOpen': "not yet contracted",
  'fc.kpi.actualOf': "{p} of the forecast reached",
  'fc.kpi.accounts': "Forecast per account",
  'fc.chartHint': "Forecast stacked per account, line = actual. Click accounts to show or hide them.",
  'fc.legendLabel': "Accounts in the chart",
  'fc.accounts': "{n} accounts · {p} projects",
  'fc.expandAll': "Expand all",
  'fc.collapseAll': "Collapse all",
  'fc.col.account': "Account / project",
  'fc.nProjects': "{n} projects",
  'fc.oneProject': "1 project",
  'fc.logoAdd': "Add logo",
  'fc.logoChange': "Change logo",
  'fc.logoSaved': "Logo saved",
  'fc.kpi.forecast': "Forecast {y}",
  'fc.kpi.ofTarget': "{p} of the annual target ({target})",
  'fc.kpi.fromFiles': "from the forecast files",
  'fc.kpi.actual': "Billed",
  'fc.kpi.actualSub': "from invoices in the tool",
  'fc.kpi.expected': "Expected year end",
  'fc.kpi.gap': "Gap to target: {v}",
  'fc.kpi.expectedSub': "actuals to last month + forecast from now",
  'fc.chart': "Revenue per month {y}",
  'fc.legend.actual': "Actual (invoices)",
  'fc.legend.forecast': "Forecast",
  'fc.count': "{n} projects",
  'fc.tableHint': "Forecast on top, actuals below. Italic: not yet contracted (Contracted = No).",
  'fc.showAll': "include projects without forecast",
  'fc.empty': "No forecast yet. Enter the Workday project ID on the project and sync.",
  'fc.col.forecast': "Forecast",
  'fc.col.actual': "Actual",
  'fc.col.expected': "Expected",
  'fc.col.target': "Target",
  'fc.sumForecast': "Total forecast",
  'fc.sumActual': "Total actual",
  'fc.noWorkdayId': "Workday project ID missing (Administration → Projects)",
  'fc.notContracted': "not yet contracted",
  'fc.help': "Source: forecast files iFC_PROJECT-#####_….xlsx in SharePoint “Project Delivery” (Dashboards/Forecast), matched via the Workday project ID. Only the months of {y} are taken over and replaced with every sync. Actual = invoices by invoice date.",
  'fc.sync.title': "Sync with the forecast files",
  'fc.sync.never': "No sync yet.",
  'fc.sync.last': "Last {at} ({by})",
  'fc.sync.files': "{n} projects taken over",
  'fc.sync.unmatched': "{n} not matched",
  'fc.sync.failed': "Sync on {at} aborted: {msg}",
  'fc.upload': "Upload file",
  'fc.uploaded': "{ok} file(s) taken over, {bad} not matched.",
  'fc.reason.unmatched': "no project with Workday ID {id}",
  'fc.reason.empty': "no values for {y}",
  // Sichtbare Seiten (Rolle „lesend“)
  "section.orders": "Orders",
  "section.projects": "Projects & targets",
  "section.invoicing": "Invoicing",
  "section.forecast": "Forecast",
  "section.issues": "Open items",
  "uf.sections": "Visible pages",
  "uf.sectionsHelp": "Only for “Read-only”. Everyone sees the start page (key figures only) and help. Pages that are not enabled disappear from the menu and are also blocked via links and export.",
  "uf.err.sections": "Please enable at least one page.",
  "sections.forbidden.title": "Not enabled",
  "sections.forbidden.text": "This page has not been enabled for you. Contact an admin if you need it.",
  // Löschen
  "del.withInvoices": "Delete – {n} invoice(s) are kept without an order",
  "del.hasAmendments": "Delete or detach the amendments first",
  "del.row": "Delete {n}",
  "del.short": "Delete? Invoices are kept",
  "del.done": "Deleted",
  "del.notAllowed": "Only the project’s PM or deputy, admins and delivery heads may delete",
  // Angebote, Nachträge, PM-Prüfung
  "pdf.warn.unsigned": "No signature found in the order confirmation section – has the offer really been accepted?",
  "pdf.warn.monthly": "Monthly framework without a total (approx. {monthly} per month) – please set the volume, e.g. months × monthly amount",
  "pdf.warn.parentMissing": "The original order {parent} does not exist in the tool yet – please create it first, then link the amendment",
  "pdf.doc.offer": "Signed offer (order confirmation)",
  "pdf.doc.changeRequest": "Change request – amendment to {parent}",
  "pdf.ocr": "Text was read from a scan with text recognition – check the figures with extra care.",
  "pdf.checked": "I have checked all values against the PDF.",
  "pdf.checkedHint": "Required when creating from the inbox. Recorded on the order with name and time.",
  "of.err.checked": "Please confirm that you have checked the values against the PDF.",
  "of.parent": "Amendment to",
  "of.parentNone": "– none (standalone order) –",
  "of.parentHint": "For change requests and top-ups: enter only the additional amount. Status and usage are calculated across the order and its amendments.",
  "order.amendmentOf": "Amendment to",
  "order.amendments": "Amendments ({n})",
  "order.amendmentsHint": "Status and usage apply to the order and its amendments together",
  "order.groupTotal": "Total incl. amendments",
  "order.thisOrder": "This order",
  "order.checkedBy": "Checked against PDF by {name} on {at}",
  "order.notChecked": "Not yet checked against the PDF",
  "order.confirmCheck": "Confirm check",
  "order.confirmed": "Check recorded",
  "orders.amendment": "Amendment",
  "orders.withAmendments": "total incl. amendments: {total}",
  "inbox.ocrPending": "reading (text recognition) …",
  "inbox.ocrFailed": "text recognition failed",
  "inbox.unsigned": "not signed",
  "inbox.offer": "Offer",
  "inbox.cr": "Amendment to {parent}",
  "inbox.pmOnly": "Review by the project’s PM/deputy or the uploader",
  "issue.inboxReview.t": "Order PDFs waiting for your review: {n}",
  "issue.inboxReview.d": "Uploaded by you or found for your project. Review and create them one after another under Orders.",
  "pz.emptyHint": "no order yet",
  "up.title": "Upload order PDFs",
  "up.drop": "Drop PDFs here or click to select several",
  "up.project": "For project",
  "up.projectPick": "Choose project …",
  "up.projectHelp": "The PDFs are reviewed for this project. You and the project’s PM/deputy can review them.",
  "up.needProject": "Please choose the project first.",
  "up.notPdf": "{file}: not a PDF, skipped",
  "up.busy": "Uploading {i} of {n} …",
  "up.done": "{n} uploaded",
  "up.known": "{n} already known",
  "up.reading": "{n} scanned, text recognition running",
  "up.failed": "{n} failed",
  "up.button": "Upload PDFs",
  "inbox.hintAll": "From the order folders or uploaded. Review and create one after another, or dismiss.",
  "inbox.startQueue": "Review one by one ({n})",
  "inbox.showAll": "Show all open ({n})",
  "inbox.showMine": "Only mine",
  "inbox.others": "{n} more open items of other projects",
  "inbox.uploadedBy": "uploaded by {name}",
  "inbox.scanned": "from order folder",
  "queue.pos": "{i} of {n}",
  "queue.skip": "Skip",
  "queue.done": "All order PDFs reviewed",
  "field.checked_by": "Checked by",
  "nav.contracts": "Contracts",
  "keys.goContracts": "Go to contracts",
  "section.contracts": "Contracts",
  "pz.noContract": "no contract",
  "ct.title": "Contracts",
  "ct.lead": "Master agreements (framework contracts) with a budget – for all areas. Each area assigns its projects; their orders count against the contract automatically. So you see whether the contract still allows further orders.",
  "ct.new": "New contract",
  "ct.searchPh": "Contract, number, project …",
  "ct.state.noBudget": "no budget",
  "ct.state.ok": "budget available",
  "ct.state.nearlyUsed": "nearly used up",
  "ct.state.exceeded": "exceeded",
  "ct.expired": "expired",
  "ct.endsIn": "ends in {n} days",
  "ct.filterEnding": "ending soon",
  "ct.filterNotFiled": "filing missing",
  "ct.empty": "No contracts yet. Use “New contract” – enter values manually or from the contract PDF.",
  "ct.emptyFilter": "No contracts for this selection.",
  "ct.col.contract": "Contract",
  "ct.col.projects": "Projects",
  "ct.col.term": "Term",
  "ct.col.budget": "Budget",
  "ct.col.ordered": "Ordered",
  "ct.col.rest": "Available",
  "ct.col.usage": "Usage",
  "ct.col.filed": "Filing",
  "ct.col.billed": "Billed",
  "ct.col.share": "Share",
  "ct.col.counts": "Counts against contract",
  "ct.col.year": "Year",
  "ct.col.yearBudget": "Annual budget",
  "ct.noProjects": "no projects yet",
  "ct.filed": "filed",
  "ct.notFiled": "filing missing",
  "ct.notFiledHint": "SharePoint link or PDF of the contract is missing",
  "ct.missingLink": "SharePoint link missing",
  "ct.missingPdf": "PDF missing",
  "ct.and": " and ",
  "ct.freeTitle": "Projects without contract ({n})",
  "ct.freeHint": "These projects belong to no master agreement.",
  "ct.freeShow": "Show",
  "ct.kind": "Master agreement",
  "ct.budgetDerived": "from project shares or annual budgets",
  "ct.usedOf": "{p} of budget",
  "ct.restHint": "for further orders",
  "ct.billedHint": "for information",
  "ct.filedOk": "Properly filed: SharePoint link and PDF are stored.",
  "ct.filedMissing": "Not completely filed: {what}. Please add via “Edit” or “Upload PDF”.",
  "ct.projectsHint": "Their orders count against this contract automatically",
  "ct.ordersTitle": "Orders on this contract ({n})",
  "ct.ordersHint": "only the lines of contract projects",
  "ct.noOrders": "No orders yet.",
  "ct.yearsTitle": "Per year",
  "ct.yearsHint": "Annual budgets are optional (under “Edit”)",
  "ct.docs": "Filing",
  "ct.openSharepoint": "Open in SharePoint",
  "ct.pdf": "Contract PDF",
  "ct.histWhat": "Contract",
  "ct.saved": "Contract saved",
  "cf.manualOrdered": "Ordered (manual)",
  "cf.manualBilled": "Billed (manual)",
  "cf.lineManualOrdered": "Ordered manually year {n} in euros",
  "cf.lineManualBilled": "Billed manually year {n} in euros",
  "cf.manualSum": "Total manual",
  "ct.manual": "manual",
  "ct.manualHint": "Manual value (earlier consumption)",
  "ct.manualConflict": "The tool also has orders of {sum} for {year} – the manual value counts.",
  "ct.manualIncl": "of which {sum} entered manually (earlier consumption)",
  "ct.col.areas": "Areas",
  "ct.col.area": "Area",
  "ct.areasTitle": "Areas",
  "ct.areasHint": "Who orders against this contract",
  "ct.homeArea": "created in {area}",
  "ct.extTitle": "Call-offs by other intive areas",
  "ct.extHint": "Areas without the Financial Tool – entered manually, count as “Ordered”",
  "ct.extRow": "other intive areas",
  "ct.extMore": "+ other intive areas",
  "ct.hiddenOrders": "Plus {n} orders from {area} ({sum}). People in that area, admins and delivery heads see them individually.",
  "ct.assign": "Assign projects",
  "cf.assign": "Assign projects from {area} to {name}",
  "cf.headLocked": "Name, term, budget, filing and call-offs can only be changed by whoever created the contract, admins and delivery heads. You can assign your area’s projects.",
  "cf.otherProjects": "Projects of other areas (assigned by their PMs): {list}",
  "cf.customerHome": "Customer from area {area}, where the contract was created.",
  "cf.ext": "Call-offs by other intive areas",
  "cf.extHelp": "For intive areas that don’t use the tool: area, amount, date (optional), note. Counts as “Ordered”. Once the area joins the tool, it assigns its projects and the entry is deleted here.",
  "cf.extArea": "Area call-off {n}",
  "cf.extAmount": "Amount call-off {n} in euros",
  "cf.extDate": "Date call-off {n}",
  "cf.extNote": "Note call-off {n}",
  "cf.extAreaPh": "e.g. intive Poland",
  "cf.extNotePh": "Note (optional)",
  "cf.addExt": "+ Call-off",
  "cf.extSum": "Total call-offs",
  "cf.err.ext": "Please enter area and amount for each call-off.",
  "cf.new": "New contract",
  "cf.edit": "Edit contract {name}",
  "cf.drop": "Drop the contract PDF here or click – number, customer, term and volume are suggested (scans too)",
  "cf.reading": "Reading PDF … (scans use text recognition, this can take a minute)",
  "cf.pdfChosen": "{file} – stored when saving. Drop another PDF here to replace.",
  "cf.pdfReplace": "Stored: {file}. Drop a new PDF here to replace.",
  "cf.pdfCheck": "Values taken from the PDF – please check.",
  "cf.pdfNoBudget": "No volume recognised – please enter manually.",
  "cf.name": "Name",
  "cf.namePh": "e.g. BMW framework contract software 2026–2027",
  "cf.number": "Contract number",
  "cf.from": "Valid from",
  "cf.to": "Valid until",
  "cf.budget": "Total budget (€)",
  "cf.budgetHelp": "Optional. Empty = sum of project shares or annual budgets.",
  "cf.projects": "Projects",
  "cf.projectsHelp": "Projects from {area}: all orders of these projects count against the contract automatically. A share per project is optional.",
  "cf.lineProject": "Project {n}",
  "cf.lineShare": "Share of project {n} in euros",
  "cf.sharePh": "Share (optional)",
  "cf.lineRemove": "Remove line {n}",
  "cf.shareSum": "Sum of shares",
  "cf.shareDiff": "The shares ({sum}) do not add up to the total budget ({budget}).",
  "cf.years": "Budget per year",
  "cf.yearsHelp": "Optional: budget per contract year. For years whose orders and invoices are not in the tool (e.g. before 2026), enter ordered or billed manually here – this replaces the tool values for that year.",
  "cf.lineYear": "Year {n}",
  "cf.lineYearBudget": "Budget of year {n} in euros",
  "cf.addYear": "+ Year",
  "cf.yearSum": "Sum of years",
  "cf.link": "SharePoint link",
  "cf.linkHelp": "Link to the contract or contract folder in SharePoint (in SharePoint: “Copy link”).",
  "cf.err.name": "Please enter a name.",
  "cf.err.customer": "Please choose the customer.",
  "cf.err.amount": "An amount or year cannot be read.",
  "cf.err.link": "The SharePoint link must start with https://.",
  "of.contractRest": "Counts against contract {name} – {rest} still available afterwards.",
  "of.contractOver": "Counts against contract {name} – exceeds the budget by {over}.",
  "of.contractNoBudget": "Counts against contract {name} (no budget).",
  "of.contractShareOver": "Share of {project} is exceeded by {over}.",
  "issue.contractExceeded.t": "Contract {contract} exceeded",
  "issue.contractExceeded.d": "Ordered {ordered} with a budget of {budget} – {over} above. Clarify an amendment to the contract.",
  "issue.contractNearlyUsed.t": "Contract {contract} nearly used up",
  "issue.contractNearlyUsed.d": "Ordered {ordered} of {budget}. Ask for an extension or top-up in time.",
  "issue.contractShareExceeded.t": "Contract {contract}: share of {project} exceeded",
  "issue.contractShareExceeded.d": "Ordered {ordered} with a share of {budget}.",
  "issue.contractEnding.t": "Contract {contract} ends in {days} days",
  "issue.contractEnding.d": "Term until {date}. Clarify a follow-up contract.",
  "issue.contractNotFiled.t": "Contract {contract} not completely filed",
  "issue.contractNotFiled.d": "{missing}. Please add it to the contract.",
  "if.payStatus": "Payment status",
  "if.payHelp": "Usually comes from the Workday sync. You can set it by hand here, e.g. when the invoice is not in Workday or the payment is known.",
  "if.paySetManual": "Set by hand on {at}. The Workday sync will only switch it to “paid”, never back to “unpaid”.",
  "if.paySetWorkday": "From the Workday sync of {at}. If you change it here, your value applies; Workday will only switch it to “paid”.",
  "if.dueDate": "Due on",
  "if.dueHelp": "Optional; from this day on the invoice counts as overdue.",
  "if.warranty": "Warranty invoice",
  "if.warrantyHelp": "Counts as revenue (forecast, billed) but not as a receivable: not in open, overdue or paid and not against the volume of a regular order.",
  "pay.warranty": "Warranty",
  "pay.warrantyHint": "Warranty: counts as revenue, not as a receivable",
  "pay.manual": "set by hand",
  "if.paidAt": "Paid on",
  "if.paidAtHelp": "Date of payment; defaults to today.",
  "if.err.paidAt": "Please enter “Paid on”.",
  "pay.paidOn": "paid on {date}",
  "pay.kpiPaid": "Paid",
  "pay.kpiPaidShare": "{p} of billed",
  "fg.title": "Forecast vs. invoices {y}",
  "fg.hint": "Forecast from January up to and including the counted month against all invoices of the year. The current month only counts from its last working day (that is when its revenue is planned to be invoiced). Customer and project filters apply; projects without a forecast are left out.",
  "fg.forecastToDate": "Forecast {r}",
  "fg.billed": "Billed {y}",
  "fg.gap": "Still to invoice",
  "fg.ahead": "Ahead",
  "fg.gapSub": "by end of {m}",
  "fg.aheadSub": "billed more than forecast so far",
  "fg.year": "Forecast full year",
  "fg.rest": "Rest to year end",
  "fg.restSub": "Full year − billed",
  "fg.col.forecast": "Forecast {r}",
  "fg.col.billed": "Billed",
  "fg.col.gap": "Still to invoice",
  "fg.col.rest": "To year end",
  "pay.oldest": "oldest {n} days",
  "pay.agingTitle": "Open by days past due",
  "fg.asOf": "As of {m}",
  "fg.fromFile": "from the forecast file",
  "pay.openNet": "open {v} net",
  "fg.nextFrom": "{m} from {d}",
  "fg.noMonth": "no month yet",
  "fg.gapNone": "no month due yet",
  "out.title": "Outstanding",
  "out.hint": "What is still to come in: open invoices (issued, not paid, net) plus what still has to be invoiced according to the forecast up to the counted month. Customer and project filters apply.",
  "out.open": "Open (not paid)",
  "out.openSub": "{n} invoices, net",
  "out.toInvoice": "Still to invoice",
  "out.toInvoiceSub": "Forecast {r} − billed",
  "out.total": "Total outstanding",
  "out.totalSub": "open + still to invoice",
  "out.col.open": "Open",
  "out.col.toInvoice": "Still to invoice",
  "out.col.total": "Outstanding",
  "out.sum": "Total",
  "fc.col.file": "Forecast file",
  "fc.unit": "Unit of monthly values",
  "fc.unitK": "Monthly values in thousand euros",
  "fc.unitEur": "Monthly values in euros",
  "fc.file.open": "Open forecast file of {n} in SharePoint",
  "fc.file.modified": "modified {d}",
  "fc.file.auto": "Link from the forecast sync",
  "fc.file.manual": "Link set by hand (Admin → Projects)",
  "fc.file.missing": "No link",
  "fc.file.missingHelp": "No forecast file known. Comes with the next sync or set it by hand under Admin → Projects & responsibilities.",
  "pf.fcFile": "Forecast file (link)",
  "pf.fcFileAuto": "automatic: {n}",
  "pf.fcFileHelp": "Leave empty: the link comes from the forecast sync. Paste your own SharePoint link (https) to override it.",
  "pf.err.fcFile": "Please enter a link starting with https://.",
  "pay.col": "Payment",
  "pay.filter": "Payment",
  "pay.paid": "paid",
  "pay.unpaid": "open",
  "pay.overdue": "overdue",
  "pay.unknown": "not synced",
  "pay.overdueDays": "{n} days overdue",
  "pay.openDays": "open for {n} days",
  "pay.dueOn": "due on {date}",
  "pay.boxTitle": "Payment status",
  "pay.boxHint": "All amounts net. Open = net invoice amount; for partial payments the amount open in Workday without 19% VAT. Customer and project filters apply.",
  "pay.kpiUnpaid": "Open",
  "pay.kpiOverdue": "of which overdue",
  "pay.kpiCount": "{n} invoices",
  "pay.age.notDue": "not due",
  "pay.age.d30": "1–30 days",
  "pay.age.d60": "31–60 days",
  "pay.age.d90": "61–90 days",
  "pay.age.more": "over 90 days",
  "pay.showOverdue": "Show overdue",
  "pay.unknownHint": "{n} invoices without payment status from Workday yet",
  "issue.invoiceOverdue.t": "Invoice {invoice} overdue for {days} days",
  "issue.invoiceOverdue.d": "{project}: {due} open, due since {date}. Follow up with the customer.",
  "nav.report": "Report",
  "rp.title": "Financial report",
  "rp.lead": "Click a report together: choose areas and projects, tick topics, check the preview and download it as a PowerPoint in the intive layout.",
  "rp.scope": "Selection",
  "rp.areas": "Areas",
  "rp.projects": "Projects",
  "rp.allProjects": "All projects of the areas",
  "rp.ownProjects": "You only see your projects (PM or deputy).",
  "rp.compare": "Comparison",
  "rp.compare.month": "with previous month",
  "rp.compare.quarter": "with end of previous quarter",
  "rp.compare.none": "no comparison",
  "rp.topics": "Topics",
  "rp.all": "All",
  "rp.none": "None",
  "rp.reportTitle": "Title (optional)",
  "rp.comment": "Comment (own slide)",
  "rp.commentPh": "Assessment, risks, next steps …",
  "rp.topic.overview": "Overview",
  "rp.topic.forecast": "Forecast",
  "rp.topic.projects": "Project status",
  "rp.topic.contracts": "Contracts",
  "rp.topic.orders": "Orders",
  "rp.topic.invoices": "Invoices",
  "rp.topic.issues": "Open items",
  "rp.topic.comment": "Comment",
  "rp.preview": "Preview",
  "rp.refresh": "Refresh preview",
  "rp.pptx": "Create PowerPoint",
  "rp.creating": "Creating PowerPoint …",
  "rp.created": "PowerPoint downloaded",
  "rp.noArea": "Please choose at least one area.",
  "rp.noTopic": "Please choose at least one topic.",
  "rp.noProjects": "No projects to choose from.",
  "rp.cmpFound": "Compared with {month}",
  "rp.cmpMissing": "There is no monthly snapshot for {month} yet – comparison from next month.",
  "rp.kpi": "Figure",
  "rp.now": "Current",
  "rp.prev": "Comparison",
  "rp.delta": "Δ",
  "rp.changes": "Changes",
  "rp.noChanges": "No significant changes.",
  "rp.k.target": "Target",
  "rp.k.ordered": "Ordered",
  "rp.k.billed": "Billed",
  "rp.k.forecast": "Forecast",
  "rp.k.expected": "Expected (actual + forecast)",
  "rp.k.uncovered": "Forecast without order",
  "rp.k.unpaid": "Invoices open",
  "rp.k.overdue": "of which overdue",
  "rp.k.urgent": "Urgent items",
  "rp.k.crit": "Critical items",
  "rp.slide": "Slide {n}",
  "rp.openOrders": "Open order volume {sum}",
  "rp.endingOrders": "Term ends within 90 days",
  "rp.noEnding": "No order ends within the next 90 days.",
  "rp.noContracts": "No contracts for the selected projects.",
  "rp.unpaidHead": "Open {sum} · overdue {over}",
  "rp.noUnpaid": "No open invoices according to Workday.",
  "rp.noIssues": "No open items.",
  "rp.days": "{n} days",
  "rp.endsOn": "ends {date}",
  "rp.forbidden": "Reports are created by PMs, admins and delivery heads.",
  "rp.prevHealth": "before {h}",
  "rp.langNote": "Report contents are in German.",
  "cf.newCustomer": "+ New customer …",
  "cf.newCustomerName": "Name of the new customer",
  "cf.newCustomerPh": "e.g. BMW AG",
  "cf.newCustomerHelp": "Created with the contract in the current area. Add its projects under Administration → Projects.",
  "cf.noCustomers": "There are no customers in this area yet – choose “+ New customer”.",
  "field.parent_order_id": "Amendment to",
  "mg.costImport": "Import cost data",
  "mg.ci.title": "Import cost data (Power BI “Project Cost Details”)",
  "mg.ci.lead": "In Power BI, export the “Project Cost Details” table (project, Heading 2, Cat_Level_2, Cat_Level_3, Category_Object, Calendar_Period, Project Costs) to Excel and upload it here. Only projects that exist in the tool are imported; others (e.g. pre-sales) are skipped.",
  "mg.ci.range": "Export: {from} to {to} · {n} projects in the tool",
  "mg.ci.semantics": "For each project and month in the export all cost items are replaced; months missing from the export stay. Status = project months.",
  "mg.ci.applied": "Imported: {n} projects",
  "mg.ci.monthsChanged": "{n} of {all} months new or changed",
  "mg.ci.notInTool": "not in the tool, skipped",
  "mg.ci.last": "Cost data · last import",
  "mg.ci.lastLine": "{at} by {by} ({file}) · {from} to {to}",
  "mg.ci.taken": "{n} projects imported",
  "mg.ci.skippedN": "{n} skipped – not in the tool",
  "mg.ci.skippedList": "Skipped: {list} (together {sum})",
  "mg.col.mix": "Cost mix",
  "mg.col.what": "What happened? ({m})",
  "mg.mix.personnel": "Personnel",
  "mg.mix.subcontracting": "Sub",
  "mg.mix.other": "Other",
  "mg.noCostData": "no cost data",
  "mg.deepDive": "Open project deep dive",
  "mg.deepDiveBtn": "Deep dive →",
  "mg.deepDiveOf": "Deep dive {p}",
  "pa.title": "Project deep dive",
  "pa.customer": "Customer",
  "pa.pm": "PM",
  "pa.deputy": "Deputy",
  "pa.target.project": "project",
  "pa.target.area": "area",
  "pa.target.default": "default",
  "pa.source": "Data from margin and cost data · {range}",
  "pa.toReport": "Add to report",
  "pa.kpi.ns": "Net sales {y}",
  "pa.kpi.hours": "{h} hours",
  "pa.kpi.cost": "Project costs {y}",
  "pa.kpi.margin": "Margin {y}",
  "pa.kpi.target": "Target {p}",
  "pa.kpi.last": "Margin {m}",
  "pa.kpi.noPrev": "no previous month",
  "pa.kpi.pts": "{d} points vs. {m}",
  "pa.ptsShort": "{d} pts",
  "pa.group.personnel": "Personnel",
  "pa.group.subcontracting": "Subcontractors",
  "pa.group.other": "Other",
  "pa.costs": "Project costs",
  "pa.chart": "Net sales, costs and margin per month",
  "pa.chartHint": "Click a month for the analysis",
  "pa.chartPct": "Number on top = margin %",
  "pa.open": "open",
  "pa.pick": "Analysis {m}",
  "pa.openMonth": "{m} still open",
  "pa.marginOf": "Margin {m}",
  "pa.what": "What happened? · {cur} compared with {prev}",
  "pa.auto": "generated automatically · appears like this in the report",
  "pa.sev.critical": "Action needed",
  "pa.sev.watch": "Watch",
  "pa.sev.info": "Note",
  "pa.sev.ok": "Unremarkable",
  "pa.noDetail": "No cost detail ({m}): for at least one of the months only the total project costs from the margin export are available. Bridge and findings then compare the total only.",
  "pa.bridge": "Margin bridge {from} → {to}",
  "pa.bridgeHint": "Green = improves the margin, red = worsens it. Costs as change to the previous month.",
  "pa.perf": "Performance compared",
  "pa.perHourNs": "Net sales per hour",
  "pa.perHourCost": "Cost per hour",
  "pa.comment": "PM comment",
  "pa.commentHint": "optional · shown here, in the margin overview and in the report",
  "pa.commentPh": "e.g. two developers on holiday; sprint 18 acceptance moved to October",
  "pa.commentMeta": "{by} · {at} · for {m}",
  "pa.commentSave": "Save comment",
  "pa.commentDelete": "Delete comment",
  "pa.table": "Cost breakdown",
  "pa.tableHint": "in k€ · expand a cost type for the single items",
  "pa.col.kind": "Cost type",
  "pa.col.share": "Share",
  "pa.noDetailMonths": "* no cost detail: {m} – only total project costs from the margin export (shown as other).",
  "pa.noCostData": "There is no cost data for this project yet; project costs come from the margin export (shown as other).",
  "rp.topic.analysis": "Margin & project analysis",
  "rp.an.which": "Which projects get their own slide?",
  "rp.an.mode.critical": "Action needed only",
  "rp.an.mode.focus": "Action needed + watch",
  "rp.an.mode.all": "All projects",
  "rp.an.modeHint": "{n} of {all} projects: {list}. The others only appear on the area slide.",
  "rp.an.parts": "Contents",
  "rp.an.part.area": "Area slide “What has changed?”",
  "rp.an.part.summary": "Plain-text summary",
  "rp.an.part.bridge": "Margin bridge",
  "rp.an.part.perf": "Performance compared",
  "rp.an.part.finds": "Findings",
  "rp.an.part.comment": "PM comment",
  "rp.an.part.costs": "Cost breakdown as appendix",
  "rp.an.partDesc.area": "Margin bridge by project and the 3 key statements",
  "rp.an.partDesc.summary": "2–3 sentences per project",
  "rp.an.partDesc.bridge": "previous month → sales → personnel → sub → other → current",
  "rp.an.partDesc.perf": "hours, sales and cost per hour",
  "rp.an.partDesc.finds": "the 3 most important, by severity",
  "rp.an.partDesc.comment": "if entered",
  "rp.an.partDesc.costs": "one slide per project with cost types × month",
  "rp.an.noData": "No margin data yet. Please import the Power BI export on the Margin page.",
  "rp.an.key": "Key points",
  "rp.an.appendix": "Appendix · cost types per month",
  // Protokoll (Aktivitätsprotokoll)
  "admin.tab.log": "Activity log",
  "log.title": "Activity log",
  "log.lead": "Who did what and when in the tool: sign-ins, page views, changes, imports, exports, administration and denied access – across all areas. Entries cannot be changed or deleted.",
  "log.from": "From",
  "log.to": "To",
  "log.person": "Person",
  "log.action": "Action",
  "log.entity": "Item type",
  "log.area": "Area",
  "log.via": "Via",
  "log.result": "Result",
  "log.ok": "OK",
  "log.failed": "Failed",
  "log.searchPh": "Order number, project, text …",
  "log.apply": "Show",
  "log.export": "As Excel",
  "log.empty": "No entries for this selection.",
  "log.more": "Load 100 more",
  "log.anonymous": "not signed in",
  "log.col.time": "Time",
  "log.col.what": "What",
  "log.col.item": "Item",
  "log.col.result": "Result",
  "log.col.changes": "Field chg.",
  "log.help": "Click a row for details and the field changes (before/after) of the same request. The Excel report contains all entries of the chosen filters (up to 50,000).",
  "log.entry": "Log entry",
  "log.planned": "planned",
  "log.request": "Request",
  "log.requestId": "Request ID",
  "log.ch.what": "Change",
  "log.ch.field": "Field",
  "log.ch.before": "Before",
  "log.ch.after": "After",
  "uf.logAccess": "Activity log: may view the activity log and download it as a report",
  "uf.logAccessHelp": "Only people who have this option themselves can grant or remove it; you cannot remove it from yourself.",
  "uf.logAccessShort": "Activity log",
  "log.leadChanges": "Who created, changed, deleted, restored or imported what – across all areas. Click a row to see the fields before/after.",
  "log.leadErrors": "What did not work: server errors, conflicts (someone else changed the item in the meantime), denied access and invalid input – with time, person and reason.",
  "log.leadAll": "Every request to the tool: page views, exports, sign-ins and syncs included.",
  "log.view": "View",
  "log.viewChanges": "Changes",
  "log.viewErrors": "Errors",
  "log.viewAll": "Everything",
  "log.recent": "Last 7 days: {n} failed – {e} server errors, {c} conflicts, {d} denied, {i} invalid",
  "log.recentNone": "Last 7 days: nothing failed",
  "log.recentHelp": "Failed requests of the last 7 days, regardless of the chosen period",
  "log.col.reason": "Reason",
  "log.helpErrors": "Click a row for the request, the reason and, for server errors, the stack trace. Server errors (500) are bugs in the tool; conflicts (409) and invalid input (400) come from usage; denied (403) means missing permissions.",
  "log.stack": "Technical details (stack trace)",
  // Projektseite, Datenstand, Offene Punkte bearbeiten (11/2026)
  "nav.group.orders": "Contracting",
  "nav.group.billing": "Billing",
  "nav.group.steering": "Steering",
  "fresh.title": "Data status",
  "fresh.chip.ok": "Data up to date",
  "fresh.chip.old": "Data: {n} out of date",
  "fresh.chip.stale": "Data: {n} stale",
  "fresh.src.workday": "Workday invoices & payments",
  "fresh.src.forecast": "Forecast files",
  "fresh.src.scan": "Order folder scan",
  "fresh.src.marginRevenue": "Revenue & hours (Power BI)",
  "fresh.src.marginCost": "Cost data (Power BI)",
  "fresh.exp.workday": "expected daily (Mon–Fri)",
  "fresh.exp.forecast": "expected daily (Mon–Fri)",
  "fresh.exp.scan": "expected daily (Mon–Fri)",
  "fresh.exp.marginRevenue": "expected monthly after month end",
  "fresh.exp.marginCost": "expected monthly after month end",
  "fresh.current": "up to date",
  "fresh.age": "{n} working days old",
  "fresh.notRunning": "not running ({n} working days)",
  "fresh.monthMissing": "{m} missing",
  "fresh.never": "never",
  "fresh.last": "last {at}",
  "fresh.until": "up to {m}",
  "fresh.help": "All syncs run through Matthias’ browser; Power BI exports are imported by hand.",
  "fresh.banner.workday": "Workday sync has not run for {n} working days",
  "fresh.banner.forecast": "Forecast sync has not run for {n} working days",
  "fresh.banner.scan": "Order folders not scanned for {n} working days – new order PDFs may be missing",
  "fresh.banner.marginRevenue": "Revenue data for {m} missing – import the Power BI export",
  "fresh.banner.marginCost": "Cost data for {m} missing – import the Power BI export",
  "pz.risk": "Target at risk",
  "pz.andBehind": "and behind plan",
  "pz.gaps": "Data gaps",
  "pz.col.expected": "Year-end expectation",
  "pz.legend.expected": "Year-end expectation",
  "pz.toTarget": "{d} vs. target",
  "pz.deputyShort": "Dep. {i}",
  "pz.say.base": "{n} projects · target {target}, billed {billed} ({p}, expected today {pace}).",
  "pz.say.behind": "{n} projects are behind plan.",
  "pz.say.risk": "According to the forecast {n} projects miss their target, most clearly {top}.",
  "pz.say.noRisk": "According to the forecast all projects reach their target.",
  "pz.riskHelp": "Target at risk: year-end expectation (actuals + forecast from the current month) more than 3% below target.",
  "pp.notFound": "This project does not exist in this area (any more).",
  "pp.deputy": "Deputy {name}",
  "pp.contract": "Contract",
  "pp.analysis": "Margin analysis",
  "pp.allOrders": "All orders",
  "pp.kpi.target": "Target",
  "pp.kpi.ordered": "Ordered",
  "pp.kpi.billed": "Billed",
  "pp.kpi.open": "Open order volume",
  "pp.kpi.expected": "Year-end expectation",
  "pp.kpi.margin": "Margin (closed months)",
  "pp.ofTarget": "{p} of target",
  "pp.ofTargetPace": "{p} of target · expected today {pace}",
  "pp.openOrders": "{n} open orders",
  "pp.toTarget": "{d} vs. target",
  "pp.noForecast": "no forecast",
  "pp.noMargin": "no margin data",
  "pp.marginSub": "{h} h this year",
  "pp.tab.ov": "Overview",
  "pp.tab.orders": "Orders",
  "pp.tab.invoices": "Invoices",
  "pp.tab.margin": "Margin",
  "pp.tab.issues": "Open items",
  "pp.chart": "Revenue per month {y} · forecast and actuals",
  "pp.chartLabel": "Forecast and billed per month",
  "pp.legend.fc": "Forecast",
  "pp.legend.act": "billed",
  "pp.fcOf": "{m}: forecast {v}",
  "pp.actOf": "{m}: billed {v}",
  "pp.months": "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
  "pp.contractOrdered": "ordered {o} of {b}",
  "pp.contractFree": "{r} still available",
  "pp.contractNoBudget": "No budget entered",
  "pp.comment": "PM comment",
  "pp.noComment": "No comment yet.",
  "pp.toComment": "Write a comment in the margin analysis – shown in the report",
  "pp.files": "Files & links",
  "pp.forecastFile": "Forecast file",
  "pp.contractFile": "Contract PDF",
  "pp.asOf": "as of {d}",
  "pp.noOrders": "No orders yet.",
  "pp.settledShow": "Show {n} settled orders",
  "pp.noInvoices": "No invoices yet.",
  "pp.col.invoice": "Invoice",
  "pp.col.date": "Date",
  "pp.col.order": "Order",
  "pp.col.net": "Net amount",
  "pp.col.payment": "Payment",
  "pp.col.month": "Month",
  "pp.col.margin": "Margin",
  "pp.paid": "paid",
  "pp.unpaid": "open",
  "pp.overdue": "{n} days overdue",
  "pp.moreHours": "more hours than average ({h} h)",
  "pp.allIssues": "All open items",
  "pp.say.ordered": "Target is {p} ordered",
  "pp.say.reach": "{ordered} and will be reached with {exp} according to the forecast.",
  "pp.say.miss": "{ordered}, but according to the forecast the project ends at {exp} ({d} vs. target).",
  "pp.say.unused": "But: {open} is ordered and not yet billed, while the forecast only plans {ye} until year end – about {rest} would remain unused.",
  "pp.say.ending": "{n} of the {m} open orders ({sum}) end soon → {act}.",
  "pp.say.extend": "request an extension",
  "pp.say.uncovered": "The forecast still lacks {x} of orders → {act}.",
  "pp.say.followUp": "request a follow-up order",
  "pp.say.overdue": "{n} invoice(s) overdue: {sum}.",
  "orders.seg.open": "Open",
  "orders.seg.settled": "Settled",
  "orders.seg.warranty": "Warranty",
  "orders.seg.alle": "All",
  "orders.endsSoon": "ends soon",
  "orders.overBilled": "{x} billed above value",
  "orders.overBilledHint": "Billed {b} for an order value of {v}",
  "issues.addNote": "+ Note",
  "issues.note": "Note",
  "issues.notePh": "What is the status? Who is on it?",
  "issues.noteSaved": "Note saved.",
  "issues.moreNotes": "… and {n} older notes",
  "issues.snoozeBtn": "Snooze",
  "issues.snooze.week": "1 week",
  "issues.snooze.twoWeeks": "2 weeks",
  "issues.snooze.monthEnd": "End of month",
  "issues.snooze.date": "Snooze until date",
  "issues.snoozedOk": "Snoozed until {d}.",
  "issues.stateSaved": "Saved.",
  "issues.unsnooze": "Reactivate",
  "issues.until": "until {d}",
  "issues.hideSnoozed": "hide snoozed ({n})",
  "issues.assignee": "Assigned to",
  "issues.assigneeDefault": "Assigned: project PM",
  "issues.bundle.ending": "{project}: {n} orders end from {date}",
  "issues.bundle.endingD": "{orders} · no follow-up order. Request a follow-up order or extension.",
  "issues.bundle.types": "Contract type missing for {n} contracts",
  "issues.mailBtn.remind": "Payment reminder",
  "issues.mailBtn.order": "Request follow-up order",
  "issues.mailBtn.extend": "Request follow-up order",
  "issues.mail.subject": "Subject",
  "issues.mail.open": "Open in mail app",
  "issues.mail.copy": "Copy",
  "issues.mail.copied": "Text copied.",
  "mail.overdue.s": "Outstanding amount invoice {invoice}",
  "mail.overdue.b": "Hello,\n\nan amount of {due} net is still outstanding on our invoice {invoice} (project {project}); it was due on {date}.\n\nCould you let us know whether there are any questions about it, or arrange the payment?\n\nThank you and kind regards\n{me}",
  "mail.nearly.s": "Order {order} – budget nearly used up",
  "mail.nearly.b": "Hello,\n\nthe budget of order {order} ({volume}) is {pct} used, {rest} remains.\n\nSo that we can continue without interruption, we kindly ask for a follow-up order or an increase. We are happy to send you an offer.\n\nKind regards\n{me}",
  "mail.ending.s": "{project}: follow-up order from {date}",
  "mail.ending.b": "Hello,\n\nthe term of order(s) {orders} for {project} ends on {date}.\n\nSo that we can continue the service without interruption, we kindly ask for a follow-up order or an extension. We are happy to send you an offer.\n\nKind regards\n{me}",
  "mail.contract.s": "Contract {contract} – extension or increase",
  "mail.contract.b": "Hello,\n\nthe contract {contract} will soon be used up or end.\n\nWe would like to discuss an extension or increase in good time. Would a short call in the next few days suit you?\n\nKind regards\n{me}",
  "fc.say.gap": "Of the {fc} forecast, {planned} was planned for {range} – {actual} has been billed. The difference of {gap} has not been invoiced yet. If it is caught up, the area ends at about the forecast ({dFc} vs. target), otherwise at {exp} ({dExp} vs. target).",
  "fc.say.ok": "Year-end expectation: {exp} ({dExp} vs. target).",
  "fc.br.title": "From forecast to expectation",
  "fc.br.target": "Target {t}",
  "fc.br.forecast": "Total forecast",
  "fc.br.rest": "of which {r}",
  "fc.br.planned": "{r} planned",
  "fc.br.gap": "not invoiced",
  "fc.br.actual": "billed",
  "fc.br.expected": "Expectation (+ {r})",
  "fc.br.where": "Where the {gap} sits",
  "fc.br.whereHint": "Forecast {r} minus invoices per project. Click opens the project page.",
  "mg.src.revenue": "Revenue & hours",
  "mg.src.cost": "Costs",
  "mg.src.until": "up to {m}",
  "mg.src.revenueFrom": "Power BI “Project Margin”, imported {d}",
  "mg.src.costFrom": "Power BI “Project Cost Details”, imported {d}",
  "mg.src.details": "Details",
  "ct.typeBanner": "Contract type missing for {n} contracts",
  "ct.typeBanner.all": "Contract type missing for all {n} contracts",
  "ct.typeBanner.why": "Fixed price, T&M, frame contract or flat fee – needed for the report and the release check.",
  "ct.typeBanner.go": "Complete",
  "pf.shortName": "Short name",
  "pf.shortNamePh": "for lists, e.g. “Brownfield”",
};

/** Englische Texte der Import-Auffälligkeiten (Deutsch kommt fertig vom Server). */
export const findingsEn: Record<string, string> = {
  missing_type: 'Row without type is skipped.',
  missing_customer: 'Row without customer is skipped.',
  missing_project: 'Row without project is skipped.',
  bad_date: 'Date “{value}” not readable, row skipped.',
  bad_amount: 'Amount “{value}” not readable, row skipped.',
  negative_amount: 'Negative amount imported.',
  target_conflict: 'Target {year} for {project} appears twice with different amounts; the later entry wins.',
  order_without_number: 'Order without order number is skipped.',
  order_customer_conflict: 'Order {order} is assigned to different customers; the first one wins.',
  invoice_without_number: 'Invoice without Workday number is skipped.',
  invoice_conflict: 'Invoice {invoice} ({project}) appears several times with different values; the later entry wins.',
  invoice_duplicate: 'Invoice {invoice} ({project}) is in several files; imported once.',
  unknown_type: 'Unknown type “{value}”, row skipped.',
  order_line_conflict: 'Order {order}: amount for {project} differs between files; {value} wins.',
  order_line_duplicate: 'Order {order} ({project}) is in several files; imported once.',
  invoice_project_not_allocated: 'Invoice {invoice} is booked on {project}, but order {order} has no line for this project.',
  order_missing: 'Order {order} is missing; {count} invoice(s) totalling {billed} refer to it. Created as order without volume.',
  order_overbilled: 'Order {order}: {pct} billed ({billed} of {volume}). Is a follow-up order missing?',
  order_and_warranty: 'Order number {order} appears as order and as warranty; both are kept separately.',
  order_number_case: 'Order number {from} normalised to {to}.',
  date_outside_file_year: '{source}: {type} dated {year}: {count} row(s). Imported with the date from the row.',
};
